import { Injectable } from '@angular/core';
import { SessionService } from '../shared/session-service/session.service';
import { SurveysFilterSortDTO } from 'src/app/shared/models/surveys-filter';
import { API_URL } from '../shared/constants/apiurl-constants';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SubmitSurveyRequest, UpdateExpenseSurveyDetailInput } from 'src/app/shared/models/SurveyDetails';
import { ExpenseSurveyCommentRequestDTO } from 'src/app/shared/models/expense-survey';
import { DeleteExpenseSurveyRequest } from '../survey/models/delete-survey-request.model';

@Injectable({ providedIn: 'root' })
export class EngagementInsigtsService {
  surveyListRefresh = new BehaviorSubject({});
  refreshSurveyList = this.surveyListRefresh.asObservable();
  private _refreshExpenseSurveyStatus = new Subject<boolean>();
  private _refreshExpenseDetail = new Subject<boolean>();
  private _refreshExpenseMessageCount = new Subject<boolean>();
  private _refreshExpenseDocumentCount = new Subject<boolean>();

  refreshExpenseDetail$: Observable<boolean> = this._refreshExpenseDetail.asObservable();
  refreshExpenseMessageCount$: Observable<boolean> = this._refreshExpenseMessageCount.asObservable();
  refreshExpenseDocumentCount$: Observable<boolean> = this._refreshExpenseDocumentCount.asObservable();
  refreshExpenseSurveyStatus$: Observable<boolean> = this._refreshExpenseSurveyStatus.asObservable();

  UnAssignSme = new BehaviorSubject({});
  UnAssignSmecall = this.UnAssignSme.asObservable();
  constructor(private sessionService: SessionService) { }

  private getEngagementId(): number {
    return this.sessionService.getSessionNumber('engagementId');
  }

  refreshTable(isRefresh: boolean) {
    this.surveyListRefresh.next(isRefresh);
  }

  refreshExpenseSurvey(isRefresh: boolean) {
    this._refreshExpenseDetail.next(isRefresh);
  }

  refreshExpenseSurveyMessageCount(isRefresh: boolean) {
    this._refreshExpenseMessageCount.next(isRefresh);
  }

  refreshExpenseSurveyDocumentCount(isRefresh: boolean) {
    this._refreshExpenseDocumentCount.next(isRefresh);
  }

  refreshExpenseSurveyStatus(isRefresh: boolean) {
    this._refreshExpenseSurveyStatus.next(isRefresh);
  }

  unAssignSmes(remove: boolean) {
    this.UnAssignSme.next(remove);
  }

  getQRE(engagementId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.INSIGHTSGETQRE + `?engagementId=${engagementId}`,
    );
  }

  getSurveyMetrics(engagementId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.INSIGHTSGETSURVEYMETRICS + `?engagementId=${engagementId}`,
    );
  }

  getSurveysFiltered(surveysFilterSort: SurveysFilterSortDTO) {
    return this.sessionService.apiUrlPost(API_URL.INSIGHTSGETSURVEYSFILTERED, surveysFilterSort);
  }

  getOpportunities(engagementId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.INSIGHTSGETOPPORTUNITIES + `?engagementId=${engagementId}`,
    );
  }

  sendEmailReminder(engagementId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.INSIGHTSSENDREMINDER + `?engagementId=${engagementId}`,
    );
  }

  getUnAssignedSurveys(engagementId: number, clientId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.GETUNASSIGNEDSURVEYS +
      '?engagementId=' +
      engagementId +
      '&clientId=' +
      clientId,
    );
  }

  exportAllSurveys(engagementId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.ExportAllSurveys + `?engagementId=${engagementId}`,
    );
  }

  assignBulkSME(surveyData): Observable<any> {
    return this.sessionService.apiUrlPost(API_URL.BulkAssignSME, surveyData);
  }

  public getEngagementById(engagementId: number, updateRecentlyViewedEngagement: boolean = false): Observable<any> {
    const id = engagementId > 0
      ? engagementId
      : this.sessionService.getSessionNumber('engagementId');
    return this.sessionService.apiUrlGet(API_URL.ENGAGEMENT.GETENGAGEMENTBYID +
      `?engagementId=${id}&updateRecentlyViewedEngagement=${updateRecentlyViewedEngagement}`,
    );
  }

  getExpenseSurveysFiltered(surveysFilterSort: SurveysFilterSortDTO) {
    return this.sessionService.apiUrlPost(API_URL.EXPENSESURVEY.GET_SURVEYSFILTERED, surveysFilterSort);
  }

  getProjectSurveysFiltered(surveysFilterSort: SurveysFilterSortDTO) {
    return this.sessionService.apiUrlPost(API_URL.PROJECTSURVEY.GET_SURVEYSFILTERED, surveysFilterSort);
  }

  deleteExpenseSurvey(engagementID: number, expenseSurveyId: number) {
    let deleteExpenseSurveyRequest = { engagementId: engagementID, expenseSurveyIds: expenseSurveyId }
    return this.sessionService.apiUrlPost(API_URL.EXPENSESURVEY.DELETE_EXPENSESURVEY, deleteExpenseSurveyRequest);
  }

  deleteExpenseSurveyMultiple(engagementId: number, expenseSurveyIds: number[]) {
    var deleteExpenseSurveysRequest: DeleteExpenseSurveyRequest = {} as DeleteExpenseSurveyRequest;
    deleteExpenseSurveysRequest.engagementId = engagementId;
    deleteExpenseSurveysRequest.expenseSurveyIds = expenseSurveyIds;
    return this.sessionService
      .apiUrlPost(API_URL.EXPENSESURVEY.DELETE_EXPENSE_SURVEY_MULTIPLE, deleteExpenseSurveysRequest);
  }

  submitExpenseSurvey(surveyData: SubmitSurveyRequest) {
    return this.sessionService.apiUrlPost(API_URL.EXPENSESURVEY.SUBMIT_EXPENSESURVEY, surveyData);
  }
  updateExpenseSurvey(surveyData: UpdateExpenseSurveyDetailInput) {
    return this.sessionService.apiUrlPost(API_URL.EXPENSESURVEY.UPDATEEXPENSESURVEYDETAILS, surveyData);
  }
  getExpenseSurveysReasonHistory(engagementID: number, surveyId: number, isClientSmeSurvey: boolean) {
    return this.sessionService.apiUrlGet(API_URL.EXPENSESURVEY.GETEXPENSESURVEYS_SUBMITREASONHISTORY + `?engagementId=${engagementID}&surveyId=${surveyId}&isClientSmeSurvey=${isClientSmeSurvey}`);
  }
  getExpenseSurveysComment(engagementID: number, surveyId: number) {
    return this.sessionService.apiUrlGet(API_URL.EXPENSESURVEY.GETEXPENSESURVEYS_COMMENTS + `?engagementId=${engagementID}&surveyId=${surveyId}`);
  }
  addExpenseSurveysComment(commentData: ExpenseSurveyCommentRequestDTO) {
    return this.sessionService.apiUrlPost(API_URL.EXPENSESURVEY.ADDEXPENSESURVEYS_COMMENTS, commentData);
  }
  getExpenseClientUsers(engagementID: number, surveyId: number) {
    return this.sessionService.apiUrlGet(API_URL.EXPENSESURVEY.GETEXPENSECLIENTUSERS + `?engagementId=${engagementID}&surveyId=${surveyId}`);
  }
}
